module.exports = __webpack_public_path__ + "f267c12d0f39d4ba3dbaa447de4aecf0.MP3";